import taskDetailsData from "@/data/task-details.json";
import tasksData from "@/data/tasks.json";
import type { Task } from "@/types";

import { mockDelay } from "./mockDelay";

export interface TaskDetail {
  aiBrief: string;
  sop: string[];
  policyNote: string;
  timeline: Array<{ timestamp: string; event: string }>;
  relatedRecords: Array<{ id: string; label: string }>;
}

export async function fetchTasks(assigneeId?: string): Promise<Task[]> {
  await mockDelay();
  const tasks = tasksData as Task[];

  if (assigneeId) {
    return tasks.filter((task) => task.assigneeId === assigneeId);
  }

  return tasks;
}

export async function fetchTaskById(taskId: string): Promise<Task | undefined> {
  await mockDelay(200);

  return (tasksData as Task[]).find((task) => task.id === taskId);
}

export async function fetchTaskDetails(
  taskId: string,
): Promise<TaskDetail | undefined> {
  await mockDelay(200);

  const details = taskDetailsData as Record<string, TaskDetail>;
  return details[taskId];
}
